






























import { defineComponent } from "@nuxtjs/composition-api";
import { formatDateTime } from "~/helpers";

export default defineComponent({
  name: "TrackingInfo",
  props: {
    info: {
      type: Object,
      required: true,
    },
  },
  components: {},

  setup() {
    const getOrderInfo = (status: string) => {
      switch (status) {
        case "Created":
          return {
            classActive: "",
            classIcon: "",
            classStatus: "Đặt hàng",
            classStatusDetail: "Đặt hàng thành công",
          };
        case "Validated":
          return {
            classActive: "",
            classIcon: "",
            classStatus: "Đang xử lý",
            classStatusDetail: "Xác nhận đơn hàng",
          };
        case "To be Prepared":
          return {
            classActive: "",
            classIcon: "",
            classStatus: "Đang xử lý",
            classStatusDetail: "Đơn hàng đang được chuẩn bị",
          };
        case "Prepared":
          return {
            classActive: "order__tracking-item--shipping",
            classIcon: "order__tracking-icon--shipping",
            classStatus: "Đang vận chuyển",
            classStatusDetail: "Đã giao cho đơn vị vận chuyển",
          };
        case "Package given to carrier":
          return {
            classActive: "order__tracking-item--delivered",
            classIcon: "order__tracking-icon--delivered",
            classStatus: "Đã giao",
            classStatusDetail: "Giao hàng thành công",
          };
        case "Cancel":
          return {
            classActive: "order__tracking-item--cancel",
            classIcon: "order__tracking-icon--cancel",
            classStatus: "Đã hủy",
            classStatusDetail: "Đơn hàng của bạn đã được hủy",
          };
        default:
          return {
            classActive: "",
            classIcon: "",
            classStatus: "",
            classStatusDetail: "",
          };
      }
    };

    return { getOrderInfo, formatDateTime };
  },
});
